<template>
  <widget-template title="Quick Launch" subTitle="Shortcuts of commonly used applications" :padded="false">
    <div v-if="initState === 1">
      <v-list v-if="items.length > 0">
        <transition-group name="slide-x-transition" tag="div">
          <v-list-tile avatar v-for="item in items" :key="item.name" @click="launchApp(item.name, item.route)" @contextmenu="renderContext($event, item)">
            <v-list-tile-avatar>
              <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
              <v-icon v-else>{{ item.route? 'mdi-launch' : 'mdi-folder'}}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              {{item.text}}
            </v-list-tile-content>
          </v-list-tile>
        </transition-group>
      </v-list>
      <v-card-text v-else>
        You have not added any Application shortcut
      </v-card-text>
    </div>
    <loader v-else :card="false" :height="150" :init="doReload" :loading="initState === 0"></loader>
    <v-menu offset-y v-model="showContextMenu" absolute :position-x="contextMenuX" :position-y="contextMenuY" :min-width="180" transition="no-transition">
      <v-list>
        <v-list-tile @click="launchApp(selectedItem.name, selectedItem.route)">
          <v-list-tile-action>
            <v-icon>mdi-open-in-new</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Open</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="toggleQuickLaunch(selectedItem.name)">
          <v-list-tile-action>
            <v-icon>mdi-delete</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Delete</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </widget-template>
</template>

<script>
import WidgetTemplate from '../WidgetTemplate'
import { mapGetters, mapActions } from 'vuex'
import Routable from '@/mixins/routable'

export default {
  data() {
    return {
      selectedItem: null,
      showContextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0
    }
  },
  computed: {
    ...mapGetters([
      'getInternalMenu'
    ]),
    items() {
      let items = []
      this.$store.state.widgets.quickLaunch.apps.map((item) => {
        const menu = this.getInternalMenu(item)
        if (menu) {
          items.push(menu)
        }
      })
      return items
    },
    initState() {
      return this.$store.state.widgets.quickLaunch.init
    }
  },
  methods: {
    ...mapActions([
      'initQuickLaunch'
    ]),
    renderContext(e, item) {
      this.selectedItem = item
      e.preventDefault()
      this.showContextMenu = false
      this.contextMenuX = e.clientX
      this.contextMenuY = e.clientY
      this.$nextTick(() => {
        this.showContextMenu = true
      })
    },
    doReload() {
      this.initQuickLaunch()
    }
  },
  mounted() {
    if (this.initState !== 1) {
      this.initQuickLaunch()
    }
  },
  mixins: [
    Routable
  ],
  components: {
    WidgetTemplate
  }
}
</script>

<style lang="scss">

</style>
